var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgendamentoTarefas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10.224,
    viewBox: "0 0 18 10.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-6.069 -9.789)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_161",
    "data-name": "Ret\\xE2ngulo 161",
    width: 8.685,
    height: 3.417,
    transform: "translate(12.217 13.462)",
    fill: "#e58005"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_162",
    "data-name": "Ret\\xE2ngulo 162",
    width: 4.586,
    height: 3.417,
    transform: "translate(13.174 13.449)",
    fill: "#00e1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M20.1,13.057v4.2a.409.409,0,0,0,.636.34l3.149-2.1a.409.409,0,0,0,0-.68l-3.149-2.1a.409.409,0,0,0-.636.34Z",
    fill: "#f70057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_163",
    "data-name": "Ret\\xE2ngulo 163",
    width: 2.614,
    height: 2.614,
    rx: 0.582,
    transform: "translate(9.231 9.789)",
    fill: "#e58005"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    cx: 4.466,
    cy: 4.466,
    r: 4.466,
    transform: "translate(6.069 11.081)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 3.879,
    cy: 3.879,
    r: 3.879,
    transform: "translate(6.655 11.668)",
    fill: "#fff7c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_164",
    "data-name": "Ret\\xE2ngulo 164",
    width: 0.316,
    height: 2.173,
    rx: 0.158,
    transform: "translate(10.377 13.374)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 0.482,
    cy: 0.482,
    r: 0.482,
    transform: "translate(10.052 15.065)",
    fill: "#e58005"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_165",
    "data-name": "Ret\\xE2ngulo 165",
    width: 2.892,
    height: 3.417,
    transform: "translate(17.211 13.435)",
    fill: "#fff100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendamentoTarefas);
export default __webpack_public_path__ + "static/media/agendamento-tarefas.a7a5702fb492635f496b1369430d624c.svg";
export { ForwardRef as ReactComponent };